import { useEffect, useRef } from 'react';
import InscricaoService from '../../../services/Inscricoes/InscricaoService';

const inscricaoService = new InscricaoService();
const TERMINAL_STATUS = ['accredited', 'rejected', 'cancelled', 'refunded', 'CONFIRMED', 'RECEIVED', 'OVERDUE', 'REFUNDED'];

export function useStatusPolling({ orderId, onStatusChange, intervalMs = 4000 }) {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!orderId) return;

    const poll = async () => {
      try {
        const response = await inscricaoService.getCheckoutStatus(orderId);
        if (response.ok) {
          const data = await response.json();
          onStatusChange?.(data);

          const status = data.status_detail || data.status;
          if (TERMINAL_STATUS.includes(status)) {
            if (intervalRef.current) clearInterval(intervalRef.current);
          }
        }
      } catch (err) {
        console.error('Erro no polling de status do pagamento:', err);
      }
    };

    intervalRef.current = setInterval(poll, intervalMs);
    poll(); // chamada imediata

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [orderId, onStatusChange, intervalMs]);
}
